export default "__VITE_ASSET__BuK_plyc__"